import React, { useState } from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import Carousel from 'react-bootstrap/Carousel';
import '../product.css';

const ProductListItem = ({ item, index, handleDelete, handleToggleChange, handleEdit, user }) => {
  const [enable, setEnable] = useState(item.enable);
  const [showAllSkus, setShowAllSkus] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  const onToggleChange = () => {
    setEnable(!enable);
    item.enable = !enable;
    handleToggleChange(item);
  };

  const isSuperAdmin = () => {
    return (user?.claims?.role === 'admin') || (user?.claims?.role === 'superAdmin');
  };

  const variantSkus = item?.variants?.map(v => v.sku).filter(Boolean) || [];
  const displayedSkus = showAllSkus ? variantSkus : variantSkus.slice(0, 2);
  const imageList = item?.imageArrayUrl?.length > 0 ? item.imageArrayUrl : [item.imageUrl];

  // Open modal and set starting slide index
  const handleImageClick = (index) => {
    setImageIndex(index);
    setShowImageModal(true);
  };

  return (
    <>
      <ListGroup.Item
        key={index + "li"}
        as="li"
        className="d-flex justify-content-between align-items-start"
      >
        {!enable && <Card.ImgOverlay />}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {/* Main Image */}
          <img
            className='product-item-image'
            src={imageList[item?.defaultImageIndex || 0] || item.imageUrl}
            onClick={() => handleImageClick(item?.defaultImageIndex || 0)}
            style={{ cursor: 'pointer' }}
          />

          {/* Thumbnail previews below main image */}
          <div style={{ display: 'flex', marginTop: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
            {imageList.slice(0, 3).map((thumb, i) => (
              <img
                key={i}
                src={thumb}
                alt={`thumb-${i}`}
                style={{
                  width: 40,
                  height: 40,
                  objectFit: 'cover',
                  border: i === (item?.defaultImageIndex || 0) ? '2px solid blue' : '1px solid #ccc',
                  borderRadius: 4,
                  marginRight: 4,
                  cursor: 'pointer'
                }}
                onClick={() => handleImageClick(i)}
              />
            ))}

            {imageList.length > 3 && (
              <div
                style={{
                  width: 40,
                  height: 40,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#eee',
                  borderRadius: 4,
                  fontSize: 12,
                  cursor: 'pointer'
                }}
                onClick={() => handleImageClick(3)}
                title={`${imageList.length - 3} more images`}
              >
                +{imageList.length - 3}
              </div>
            )}
          </div>
        </div>

        <div className="me-auto product-list-row ml-20">
          <div className='flex-row'>
            <div className='bold-font'>Vendor:</div>
            <div className='ml-10 txt-eclipse'><strong>{item.vendor?.displayName || '--'}</strong></div>
          </div>

          <div className='flex-row'>
            <div className='bold-font'>Product Id:</div>
            <div className="ml-10 txt-eclipse">{item.id}</div>
          </div>

          <div className='flex-row'>
            <div className='bold-font'>Product Name:</div>
            <div className="ml-10 txt-eclipse">{item.itemName}</div>
          </div>

          <div className='flex-row'>
            <div className='bold-font'>Current Price:</div>
            <div className='ml-10'>₹{item.currentPrice || '---'}</div>
          </div>

          <div className='flex-row'>
            <div className='bold-font'>Member Price:</div>
            <div className='ml-10'>₹{item.memberPrice || '---'}</div>
          </div>

          <div className='flex-row'>
            <div className='bold-font'>Old Price:</div>
            <div className='ml-10'>₹{item.oldPrice || '---'}</div>
          </div>

          <div className='flex-row'>
            <div className='bold-font'>Quantity:</div>
            <div className='ml-10'>{item.quantity || '---'}</div>
          </div>

          <div className='flex-row'>
            <div className='bold-font'>Description:</div>
            <div className='ml-10 txt-eclipse'>{item.desc || '--'}</div>
          </div>


          {variantSkus.length > 0 && (
            <div className='flex-row'>
              <div className='bold-font'>Variant SKUs:</div>
              <div className='ml-10'>
                {displayedSkus.join(', ')}
                {variantSkus.length > 2 && (
                  <span
                    onClick={() => setShowAllSkus(!showAllSkus)}
                    className="sku-toggle"
                    style={{ color: 'blue', cursor: 'pointer', marginLeft: 8 }}
                  >
                    {showAllSkus ? 'Less' : 'More'}
                  </span>
                )}
              </div>
            </div>
          )}
        </div>

        <div>
          <div className='settings'>
            {isSuperAdmin() && (
              <i className="bi bi-trash product-setting" onClick={() => handleDelete(item)}></i>
            )}
            <i className="bi bi-pen product-setting ml-10" onClick={() => handleEdit(item)}></i>
          </div>
          <i
            className={enable ? "bi bi-toggle-on product-toggle-left" : "bi bi-toggle-off product-toggle-left"}
            onClick={onToggleChange}
          ></i>
        </div>
      </ListGroup.Item>

      {/* Image Modal */}
      <Modal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Product Images</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Carousel
            interval={null}
            indicators={true}
            controls={true}
            keyboard={true}
            touch={true}
            activeIndex={imageIndex}
            onSelect={(selectedIndex) => setImageIndex(selectedIndex)}
          >
            {imageList.map((img, i) => (
              <Carousel.Item key={i}>
                <img
                  className="d-block w-100"
                  src={img}
                  alt={`Slide ${i + 1}`}
                  style={{ maxHeight: 500, objectFit: 'contain' }}
                />
              </Carousel.Item>
            ))}
          </Carousel>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ProductListItem;
